export function isWdErrorResponse(response) {
    if (response != null) {
        return Object.hasOwn(response, "error");
    }
    else
        return false;
}
//# sourceMappingURL=error.js.map